import store from "@/store/";
import contractModule from '@/store/modules/contract/index'
import inscriptionService from "@/services/inscriptionService";
import leadService from "@/services/leadService";
import { i18n } from "@/locales/index.js";
import enums from "@/enums";

export default async ({ from, to, next }) => {
  if(to.params.lead !== undefined) {
    console.log('middleware - lead');
    store.commit("common/setCameFrom", 'lead');
    let completedSteps = ['PersonalDetails', 'SituationContext', 'Consumption'];

    // Comment because of agentCheckEan
    // store.commit("subscription/reset");
    // store.commit("consumption/reset"); // because there a problem with store module
    // store.commit("contract/reset");


    const sub = await inscriptionService.getSubscriptionByLead(to.params.lead);

    await store.dispatch("subscription/setSubscription", sub)

    const lead = await leadService.get(to.params.lead);
    await store.dispatch(`consumption/setConsumption`, lead);


    const customerTypeArray = Object.values(enums.customerTypeEnum);
    if(lead.prospectType &&
      customerTypeArray.includes(lead.prospectType) &&
      !customerTypeArray.includes(store.state.subscription.customerType)) {
      store.commit("subscription/setCustomerType", lead.prospectType);
    }

    await store.dispatch('common/saveLeadDataForEmail', lead);

    await store.dispatch("contract/setContract", sub.contracts[0]);
    let response = await store.dispatch("contract/setProductWithLead", lead);
    if(response === 'Offer') { completedSteps.push('Offer') }

    let contracts = sub.contracts;
    contracts.shift();

    contracts.forEach(async contract => {
      store.commit("subscription/pushContract", contract.id);
      store.registerModule(contract.id, contractModule);
      await store.dispatch(`${contract.id}/setContract`, contract);
    })

    store.commit("common/setCompletedSteps", completedSteps);

    // PRICE EXPLOSION
    // if(process.env.BLOCK_CUSTOMERS) {
    //   console.log('coucou');
    //   return next(`/${i18n.locale}/situation/personal-details`, {query: to.query});
    // }

    if(! (sub.contact.first_name && sub.contact.first_name.length) || ! (sub.contact.last_name && sub.contact.last_name.length)) {
      return next(`/${i18n.locale}/situation/personal-details`, {query: to.query});
    }

    if(response === 'Offer') {
      return next(`/${i18n.locale}/contract`, {query: to.query});
    }

    return next(`/${i18n.locale}/offer`, {query: to.query});
  }

  return next(`/${i18n.locale}/situation/personal-details`, {query: to.query});
}



// WEBPACK FOOTER //
// ./src/router/middleware/lead.js